import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import {
    CertificateExtended,
    CertificateQueryParams,
    EquipmentCertificateExtendedListResponse,
    UserCertificateExtendedListResponse
} from '@frontend/certificate/types';

export class CertificateExtendedClient extends APIClient {
    public static readonly endpoint = '/certificate-api/ext/v1';

    public static async fetchExpiredCertifiedEquipmentsInUse(
        queryParams?: ApiQueryParams<DefaultQueryParams>
    ): Promise<EquipmentCertificateExtendedListResponse> {
        return this.apiPaginated<EquipmentCertificateExtendedListResponse, DefaultQueryParams>(
            `${this.endpoint}/expired-certified-equipments-in-use`,
            queryParams
        );
    }

    public static async fetchEquipmentCertificates(queryParams?: ApiQueryParams<CertificateQueryParams>): Promise<EquipmentCertificateExtendedListResponse> {
        return this.apiPaginated<EquipmentCertificateExtendedListResponse, CertificateQueryParams>(`${this.endpoint}/equipment-certificates`, queryParams);
    }

    public static async fetchUserCertificates(queryParams?: ApiQueryParams<CertificateQueryParams>): Promise<UserCertificateExtendedListResponse> {
        return this.apiPaginated<UserCertificateExtendedListResponse, CertificateQueryParams>(`${this.endpoint}/user-certificates`, queryParams);
    }

    public static async fetchCertificate(accountId: string, certificateId: string): Promise<CertificateExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/certificates/${certificateId}`);
        return await this.handleResponse<CertificateExtended>(response);
    }
}
